
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'badge badge--bottom-left color-accent-1 cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n        ', badge, '\n      ');
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI3(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function onClick4() {
                    window.GorgiasChat.open();
                }
                return _createElement('a', {
                    'href': this.url,
                    'className': 'card card--standard card--media'
                }, _createElement('div', { 'className': 'card__inner gradient' }, _createElement('div', { 'className': 'card__media' }, _createElement('div', { 'className': 'media--transparent media--hover-effect' }, _createElement('img', {
                    'className': 'motion-reduce',
                    'data-sizes': 'auto',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }))), _createElement.apply(this, [
                    'div',
                    { 'className': 'card__badge top left' },
                    this.on_sale ? _createElement('span', {
                        'className': 'badge badge--bottom-left color-accent-1',
                        'key': '436'
                    }, 'Sale') : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ])), _createElement('div', { 'className': 'card__content' }, _createElement('div', { 'className': 'card__information' }, _createElement('h3', { 'className': 'card__heading h5' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'full-unstyled-link'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('div', { 'className': 'card-information' }, [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '10940'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI3.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], _createElement('div', { 'className': 'price' + (this.on_sale ? ' price--on-sale' : '') }, _createElement('div', { 'className': 'price__container' }, _createElement('div', { 'className': 'price__regular' }, _createElement('span', { 'className': 'visually-hidden visually-hidden--inline' }, 'Regular price'), _createElement('span', { 'className': 'price-item price-item--regular' }, '\n                ', this.price_varies ? `${ _translate(`price_from`) } ` : '', _createElement('strong', {}, this.formatPrice(this.min_price || this.price)))), this.on_sale ? _createElement('div', {
                    'className': 'price__sale',
                    'key': '2018'
                }, _createElement('span', { 'className': 'visually-hidden visually-hidden--inline' }, 'Regular price'), _createElement('span', {}, _createElement('s', { 'className': 'price-item price-item--regular price-item--old' }, this.formatPrice(this.compare_at_price))), _createElement('span', { 'className': 'visually-hidden visually-hidden--inline' }, 'Sale price'), _createElement('span', { 'className': 'price-item price-item--sale price-item--last' }, '\n                ', this.price_varies ? `${ _translate(`price_from`) } ` : '', _createElement('strong', {}, this.formatPrice(this.min_price || this.price)))) : null)), !this.is_bundle ? _createElement('div', {
                    'className': 'product__inventory',
                    'key': '2714'
                }, this.stock_status === 'out_of_stock' ? [
                    _createElement('span', {
                        'className': 'material-symbols-sharp',
                        'key': '27811'
                    }, 'cancel'),
                    _createElement('span', { 'key': '27813' }, this.stock_primary_text)
                ] : null, this.stock_status && this.stock_status !== 'out_of_stock' ? [
                    _createElement('span', {
                        'className': 'material-symbols-sharp',
                        'key': '29971'
                    }, 'check_box'),
                    _createElement('span', {
                        'className': 'stock_label',
                        'key': '29973'
                    }, '\n              ', this.show_qty && this.stock_quantity_text ? this.stock_quantity_text : this.stock_primary_text, ' \n            '),
                    this.stock_secondary_text ? [
                        this.stock_secondary_text === 'Contact us for stock status on this item.' ? [_createElement('span', {
                                'className': 'note',
                                'key': '34211'
                            }, _createElement('a', {
                                'onClick': onClick4.bind(this),
                                'href': '#'
                            }, ' Contact us '), _createElement('span', {}, 'for stock status on this item.'))] : null,
                        this.stock_secondary_text !== 'Contact us for stock status on this item.' ? [
                            '\n                ',
                            this.stock_secondary_text,
                            '\n              '
                        ] : null
                    ] : null
                ] : null) : null)), _createElement('div', { 'className': 'cm_product-item__buttons' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'cm_product-item__buttons-form',
                    'id': this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids?.length > 1 || this.is_bundle ? [_createElement('a', {
                        'className': 'cm_button cm_button__secondary',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '42281'
                    }, '\n            ', this.out_of_stock ? 'Sold out' : 'Select options', '\n          ')] : null, (this.parent_id || this.variant_ids?.length === 1) && !this.is_bundle ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.parent_id ? this.id : this.variant_ids,
                        'key': '45191'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '45193'
                    }),
                    this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '45195'
                    }) : null,
                    _createElement('button', {
                        'className': 'cm_button cm_button__primary',
                        'type': 'submit',
                        'data-form-id': this.parent_id || this.id,
                        'disabled': this.out_of_stock,
                        'key': '45197'
                    }, this.out_of_stock ? ['Sold out'] : null, !this.out_of_stock ? [
                        'Add to cart',
                        this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : ''
                    ] : null)
                ] : null))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'grid cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []